import { type IntlShape } from 'react-intl'

import { i18nGetCurrencyForLocale, i18nGetCurrencySymbol } from '../i18n'

import { getStringValuesJoinedByNonBreakingSpace } from './getStringValuesJoinedByNonBreakingSpace'

export const priceGetFormattedValueDiscount = (
  value: number,
  intl: IntlShape,
): string =>
  getStringValuesJoinedByNonBreakingSpace([
    intl.formatNumber(value, {
      minimumFractionDigits: 2,
    }),
    i18nGetCurrencySymbol(i18nGetCurrencyForLocale(intl.locale), intl),
  ])
